import styled from 'styled-components';

export const WrapperStyled = styled.div`
  display: flex;
  gap: 8px;
  height: 50px;
  align-items: center;
  justify-content: space-between;
`;

export const LabelWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const VerticalWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;

export const TextWithOverflowStyled = styled.div<{ width: string }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
`;

export const DescriptionStyled = styled.div`
  font-size: 12px;
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
`;

export const StatusWrapperStyled = styled.div`
  display: flex;
  align-items: end;
  gap: 4px;
`;

export const ProjectIconStyled = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 4px;
`;

export const TestCycleInfoWrapperStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: start;
`;

export const ExecutionDetailsWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
  max-width: 150px;
  min-width: 150px;
`;

export const StatusDescriptionStyled = styled.div`
  padding-bottom: 4px;
  height: 16px;
  font-weight: 700;
  font-size: 11px;
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  justify-content: end;
`;
